import { useSyncExternalStore } from "react";
import type { PlanEvent } from "../../../shared/types";

let current: PlanEvent | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const fn of listeners) fn();
}

export function setClipboardEvent(event: PlanEvent | null) {
  current = event;
  emit();
}

export function getClipboardEvent(): PlanEvent | null {
  return current;
}

export function useClipboardEvent(): PlanEvent | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}
